/**
 * @generated SignedSource<<973f011b30771219c50cf35e8ee8f72b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_shippingFilters$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
  readonly " $fragmentType": "SbRespComponents_shippingFilters";
}>;
export type SbRespComponents_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: SbRespComponents_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespComponents_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespComponents_shippingFilters",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPersonalizedFilterToast_shippingFilters"
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "efe06964b9b07555da0ee972e23cecaa";

export default node;
